import { darken, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modal: {
    [theme.breakpoints.down('sm')]: {
      overflowY: 'auto'
    }
  },
  deletePaper: {
    margin: 'auto',
    width: '60%',
    minWidth: 800,
    padding: 24,
    marginTop: '15vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      minWidth: 'unset',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  deleteIcon: {
    margin: 'auto',
    fontSize: 80,
    position: 'absolute',
    backgroundColor:
      theme.palette.type === 'dark'
        ? darken(theme.palette.background.default, 0.3)
        : '#f7f7f7',
    padding: 10,
    borderRadius: '50%',
    top: -42,
    color: theme.palette.primary.dark,
    left: 'calc(50% - 40px)'
  },
  title: {
    marginTop: 30,
    textAlign: 'center',
    marginBottom: 24
  },
  description: {
    textAlign: 'center',
    marginBottom: 8
  },
  deleteButton: {
    // backgroundColor: 'red',
    // color: 'white',
    marginLeft: 8
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  tableRow: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 12,
    // '&>div': {
    //   backgroundColor: 'white',
    //   padding: 12
    // },
    transition: 'background-color 0.3s ease-in-out',
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? darken(theme.palette.background.default, 0.3)
          : '#f0f0f0'
    }
  },
  tableRowMobile: {
    paddingTop: 10,
    paddingBottom: 10,
    borderTop: '1px solid gray',
    position: 'relative'
  },
  expireDateCell: {
    flex: 3
  },
  expireDateCellmobile: {
    paddingLeft: 10,
    paddingTop: 10,
    flex: 3
  },
  APIKeyCell: {
    flex: 7,
    display: '-webkit-box',
    lineClamp: 1,
    boxOrient: 'vertical',
    overflow: 'hidden',
    position: 'relative',
    paddingRight: 30
  },
  APIKeyCellMobile: {
    background: '#dddddd',
    border: '1px solid gray',
    padding: 4,
    borderRadius: 8,
    marginBottom: 8,
    position: 'relative'
  },
  descriptionCell: {
    paddingLeft: 10,
    flex: 7
  },
  descriptionCellmobile: {
    paddingLeft: 10,
    paddingTop: 10,
    flex: 7
  },
  deleteIconCell: {
    flex: 1
  },
  copiedIconCell: {},
  deleteIconCellMobile: {
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'absolute',
    top: '42%',
    right: 0,
    '& button': {
      color: 'white'
    }
  },
  tableHead: {
    display: 'grid',
    gridTemplateColumns: '3fr 7fr 7fr 1fr',
    alignItems: 'center',
    padding: '6px 0 6px 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor:
      theme.palette.type === 'dark'
        ? darken(theme.palette.background.default, 0.3)
        : '#f7f7f7',
    borderRadius: 12
  },
  copyIconButton: {
    position: 'absolute',
    top: -10,
    right: 0,
    zIndex: 1,
    '& svg': {
      fontSize: 20
    }
  },
  copyIconButtonMobile: {
    position: 'absolute',
    backgroundColor: '#dddddd',
    top: -8,
    right: 0,
    '& svg': {
      fontSize: 20
    }
  },
  skeleton: {
    marginTop: '14px!important',
    marginBottom: '14px!important',
    width: '80%'
  },
  deleteIconMobile: {
    fontSize: 40,
    padding: 4,
    color: '#7f7f7f'
  },
  deleteButtonMobile: {
    margin: 'auto',
    fontSize: 80,
    padding: 10,
    borderRadius: '50%'
  },
  noDataImageContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 400
  }
}))

export default useStyles
